module.exports = __webpack_public_path__ + "img/right.d5fc857e.png";